import { displayShell } from '../boot/displayShell';

const UPDATE_CHECK_MS = 60 * 60 * 1000;

/**
 * Production only, after the page has loaded (it never competes with
 * startup). Updates wait for the player to press Refresh on the title
 * screen; nothing reloads mid-battle, mid-scene or mid-minigame.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  const base = import.meta.env.BASE_URL;
  let reloadWanted = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!reloadWanted) return;
    reloadWanted = false;
    window.location.reload();
  });

  const offer = (worker: ServiceWorker) => {
    displayShell.offerUpdate(() => {
      reloadWanted = true;
      worker.postMessage({ type: 'SKIP_WAITING' });
    });
  };

  const register = () => {
    navigator.serviceWorker
      .register(`${base}sw.js`, { scope: base })
      .then((reg) => {
        if (reg.waiting && navigator.serviceWorker.controller) offer(reg.waiting);
        reg.addEventListener('updatefound', () => {
          const worker = reg.installing;
          worker?.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) offer(worker);
          });
        });
        const check = () => void reg.update().catch(() => undefined);
        window.setInterval(check, UPDATE_CHECK_MS);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') check();
        });
      })
      .catch(() => undefined);
  };

  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
}
